import { fromPairs, IdentifiableMap, } from "../../collections";
import { makeImmutable } from "../../core";
import { CustomParameterInstances } from "./CustomParameterInstances";
import { ProductInstanceParts, } from "./ProductInstanceParts";
/**
 * ProductInstance is a collection of common custom parameters, common modifiers, and parts (which hold per-part modifiers).
 * Common pittfall: Each product instance part can be of different product type, so we cannot say that ProductInstance is an instance of a ProductType
 * Can be split into parts.1
 * Example: Large Margherita on thick dough with onion rings
 */
export class ProductInstance {
    constructor(params) {
        this.customParameterInstances = params.customParameterInstances;
        this.commonModifierInstances = params.commonModifierInstances;
        this.parts = params.parts;
        makeImmutable(this);
    }
    eq(other) {
        return (IdentifiableMap.eq("typeId", this.customParameterInstances, other.customParameterInstances) &&
            IdentifiableMap.eq("typeId", this.commonModifierInstances, other.commonModifierInstances) &&
            ProductInstanceParts.eq(this.parts, other.parts));
    }
    /*
     * NOTICE This equivalence is not symmetrical
     * burger with size = large is cart equivalent to a burger with size = large and doneness = rare
     * but not vice versa
     */
    isCartEquivalentTo(other) {
        for (const [thisParamType, thisParamChoice] of this
            .customParameterInstances) {
            const otherParamChoice = other.customParameterInstances.find(thisParamType);
            if (otherParamChoice === null || !otherParamChoice.eq(thisParamChoice)) {
                return false;
            }
        }
        return ProductInstanceParts.isCartEquivalentTo(this.parts, other.parts);
    }
    get productCategoryId() {
        return this.parts.productCategoryId;
    }
    get productTypeIds() {
        return this.parts.productTypeIds;
    }
    get productWeeklySchedule() {
        return this.parts.productWeeklySchedule;
    }
    get customParameters() {
        return CustomParameterInstances.toCustomParameterSet(this.customParameterInstances);
    }
    get modifierInstances() {
        return this.commonModifierInstances.objects.concatenated(this.parts.modifierInstances);
    }
    matchesCustomParameterValue(customParameterTypeId, customParameterChoiceId) {
        var _a, _b, _c;
        return ((_c = (_b = (_a = this.customParameterInstances
            .find(customParameterTypeId)) === null || _a === void 0 ? void 0 : _a.selectedChoice) === null || _b === void 0 ? void 0 : _b.eq(customParameterChoiceId)) !== null && _c !== void 0 ? _c : false);
    }
    storageData(trackingId) {
        return {
            trackingId: trackingId.value,
            commonConfig: {
                customParameterInstances: fromPairs(this.customParameterInstances.objects.mapOptional((customParameterInstance) => customParameterInstance.storageData === null
                    ? null
                    : [
                        customParameterInstance.typeId.value,
                        customParameterInstance.storageData,
                    ])),
                modifierInstances: fromPairs(this.commonModifierInstances.objects.map((modifierInstance) => [
                    modifierInstance.typeId.value,
                    modifierInstance.storageData,
                ])),
            },
            parts: this.parts.storageData,
        };
    }
    get name() {
        return this.parts.parts.raw
            .map((part) => {
            return part.productType.name.value;
        })
            .join(" / ");
    }
}
